

import { Box, Grid } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../Components/Table/CustomTable'
import { useDispatch, useSelector } from 'react-redux';
import { setHeaderName, setSubHeaderName } from '../../../../ReduxStore/Slices/headerSlice';
import { Assessment } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import actions from '../../../../ReduxStore/actions';
// import AppraisalPdfGenerator from './AppraisalPdfGenerator';

const DepartmentAppraisal = () => {
    const tableHeadData = ["S.No", "Employee ID", "Employee Name", "Designation", "Email ID", "DOJ", "Department", "Sub Department", "Reporting to", "Reviewer", "Assessment Period", "Status of Appraisal", "View Details"

    ];
    const tableData = [
        { appraisalFormId: "5555ASSEMBLY SUPERVISOR-34", employeeId: "5555", employeeName: "Vallarasu K", designation: "ASSEMBLY SUPERVISOR", emailId: "valla@gmail.com", doj: "01 -08 - 2023", department: "ASSEMBLY", reportingTo: "--", reviewer: "--", assessment: "2024-2025", period: "2024-2025", statusOfApproval: "Self Evaluation Completed", viewDetails: "View Details" },


    ]
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(setHeaderName("Department Appraisal"));
        dispatch(setSubHeaderName(""));
    }, [dispatch]);

    const navigate = useNavigate()

    // const handleEnterForm = () => {
    //     navigate("/employee/departmentappraisalform")

    // }
    // const handleEnterForm = (kra_kpi_id, employee_id, appraisalyearid) => {
    //     navigate(`/employee/departmentappraisalform/${kra_kpi_id}${employee_id}${appraisalyearid}`)

    // }


    const handleEnterForm = (kra_kpi_id, employeeId, appraisalyearid) => {
        // navigate(`/employee/myappraisalform/${kra_kpi_id}${employeeId}${appraisalyearid}`)
        navigate('/employee/departmentappraisalform', {
            state: {
                kra_kpi_id,
                employeeId,
                appraisalyearid
            }
        });


    }
    const { getReviewerEmployeeKraKpiStatusList } = useSelector((state) => state?.getReviewerEmployeeKraKpiStatusList);

    const employeeId = localStorage.getItem("employeeId")


    useEffect(() => {
        // const fetchData = async () => {

        const data1 = {
            data: {},
            method: "get",
            apiName: `getReviewerEmployeeKraKpiStatusList`
        };
        dispatch(actions.GETREVIEWREMPLOYEEKRAKPISTATUSLIST(data1));

        // }
        // fetchData()

    }, [])


    const [rowTableData, setRowTableData] = useState([])
    console.log(rowTableData, "rowTableTAdatatattattat")




    useEffect(() => {

        const tempArr = [];
        getReviewerEmployeeKraKpiStatusList?.data?.map((data, index) => {
            return tempArr.push({
                // kra_kpi_question_id: data?.kra_kpi_question_id,
                kra_kpi_id: data?.kra_kpi_id,
                // id: data?.kra_kpi_id,
                // id: data?.kra_kpi_name,
                appraisalyearid: data?.appraisal_year_id,

                employeeId: data?.employee_id,
                employee_code: data?.employee_code,

                employee_name: data?.employee_name,
                designation_name: data?.designation_name,
                email: data?.email || "--",
                date_of_joining: data?.date_of_joining || "--",
                department_name: data?.department_name,
                sub_department_name: data?.sub_department_name,
                reportingTo: data?.reporting_manager_name || "--",
                reviewer: data?.reviewer_name || "--",
                appraisal_year: data?.appraisal_year || "--",
                appraisal_current_status: [data?.appraisal_current_status || "--", data?.appraisal_current_status === "manager evaluation completed" ? "--" : data?.reviewer_reject_comment || "--"],
                viewDetails: "View Details",
                // reAppeal: data?.appraisal_current_status === "not started" ? "--" : "Request For Re Apply",
                // downloadForm: "downloadForm",
                // downloadAppraisalletter: "downloadAppraisalletter"
                // reviewer: data?.reviewer || "--",





            });
        });
        setRowTableData(tempArr);




    }, [getReviewerEmployeeKraKpiStatusList])


    return (
        <div>
            <Box
                sx={{
                    background: "white",
                    p: 3,
                    mt: 6,
                    // maxWidth: "950px"
                }}
            >
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12 }} sx={{ width: "100px", flex: 1 }}>
                        <CustomTable
                            tableHeadData={tableHeadData}
                            tableData={rowTableData}
                            title="Department Appraisal"
                            handleEnterForm={handleEnterForm}
                            // downloadForm={true}
                            // tableEdit={true}
                            // tableActions={true}
                            tableSearch={true}
                            viewDetailsEnterForNotStarted="reviewer"
                        // tableActivate={true}

                        />

                    </Grid>
                </Grid>

                {/* <AppraisalPdfGenerator /> */}

            </Box></div>
    )
}

export default DepartmentAppraisal